<template>
    <v-overlay v-model="displayOverlay" contained height="100%" width="100%" style="width:100%;height:100%;">
        <table style="width:100%;height:100%">
            <tr>
                <td valign="middle" align="center">
                    <v-progress-circular color="white" indeterminate></v-progress-circular>
                </td>
            </tr>
        </table>
    </v-overlay>
</template>

<script>
    export default {

        name: 'common-spinner',
        props: {
            loading: {
                default: false,
                type: Boolean
            }
        },
        components:{
            
        },
        methods: {
            
        },
        data() {
            return {
                displayOverlay:false,
            };
        },
        watch: {
            loading: function (newVal) {
                this.displayOverlay = newVal;
            },
        },
        mounted() {
            this.displayOverlay = this.loading;
        },
        setup () {
            return {};
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
